import {useContext, useMemo} from 'react';

import {InternalContext} from '../../store/context';
import {Action} from '../../store/actions';

export interface UseArrowFocusTrapItemActionArguments {
	disabled?: boolean;
	index: number;
}

export const useArrowFocusItemAction = ({
	disabled: _disabled,
	index,
}: UseArrowFocusTrapItemActionArguments) => {
	const {
		activeIndex,
		disabled,
		handleItemClick,
		handleItemInteractStart,
		dispatch,
		setActiveIndex,
	} = useContext(InternalContext);

	const isActive = !disabled && activeIndex === index;
	const tabIndex = isActive ? 0 : -1;

	const memoizedAttributes = useMemo(
		() => ({
			tabIndex,
			onClick: (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
				if (_disabled) return;
				event.stopPropagation();
			},
			onBlur: (event?: React.FocusEvent<HTMLElement>) => {
				dispatch({type: Action.EnableClickKeys});
			},
			onFocus: (event?: React.FocusEvent<HTMLElement>) => {
				dispatch({type: Action.DisableClickKeys});
			},
			handleMenuOpen:
				(ocb?: (...args: any) => any) =>
				(...args: any) => {
					dispatch({type: Action.DisableKeys});
					ocb?.(...args);
				},
			handleMenuClose:
				(ocb?: (...args: any) => any) =>
				(...args: any) => {
					dispatch({type: Action.EnableKeys});
					ocb?.(...args);
				},
		}),
		[tabIndex],
	);

	return {
		attributes: memoizedAttributes,
		handleItemClick,
		handleItemInteractStart,
		isActive,
		setActiveIndex,
	};
};

export default useArrowFocusItemAction;
